<script setup lang="ts">
import { Head, usePage } from '@inertiajs/vue3'

import HeadingSmall from '@/components/HeadingSmall.vue'
import PodiumWebhookCard from '@/components/settings/PodiumWebhookCard.vue'
import TokenList from '@/components/settings/TokenList.vue'
import AppLayout from '@/layouts/AppLayout.vue'
import SettingsLayout from '@/layouts/settings/Layout.vue'
import { settingsTokenPath, settingsTokensPath } from '@/routes'

interface Token {
  id: number
  name: string
  access: 'read' | 'read_write'
  last_used_at: string | null
  expires_at: string | null
  created_at: string
}

interface PodiumWebhook {
  uid: string
  url: string
  eventTypes: string[]
  disabled: boolean
  secret?: string
  createdAt: string
  updatedAt: string
}

interface Props {
  tokens: Token[]
  podium_webhooks: PodiumWebhook[] | null
  webhook_event_types: Record<string, string[]>
  podium_connected: boolean
}

defineProps<Props>()

const page = usePage<{ auth: { roles: string[] } }>()
const isAdmin = page.props.auth.roles.includes('admin')
</script>

<template>
  <Head title="API Tokens" />
  <AppLayout>
    <SettingsLayout>
      <div class="space-y-6">
        <HeadingSmall
          title="API Tokens"
          description="Create tokens for programmatic access to the TLC API."
        />

        <TokenList
          :tokens="tokens"
          :create-path="settingsTokensPath()"
          :destroy-path="(id) => settingsTokenPath(id)"
        />

        <!-- Podium Webhook management — admin only -->
        <template v-if="isAdmin">
          <PodiumWebhookCard
            :webhooks="podium_webhooks"
            :event-type-groups="webhook_event_types"
            :connected="podium_connected"
          />
        </template>
      </div>
    </SettingsLayout>
  </AppLayout>
</template>
